export const routes = {
  DEFAULT: "/",
  DEFAULT_LOGIN: "/:urlParam", 
  DASHBOARD: "/dashboard",
  CONTACT: "/inquiry",
  PROFILE: "/profile",
  EDITPROFILE: "/edit-profile",
  CONTENT_MANAGEMENT: "/content",
  // USER_PROFILE: "/user/profile",
  // USER_REPORT: "/user/profile/report",
  // USER_NETWORK: "/user/profile/network",
  FAQS: "/faqs",
  // WHITEPAPER: "/whitepaper",
  // USER: "/user",
  // TRANSACTION: "/transaction",
  // ADMIN_WALLET: "/wallet",
  // LOCK_WALLET: "/lockwallet",
  // PACKAGES: "/packages",
  // NAKAMOTO_TUTORIALS: "/nakamoto-tutorials",
  CHANGEPASSWORD: "/change-password",
  SIGNIN: "/auth/signin",
  SIGNUP: "/auth/signup",
  FORGOTPASSWORD: "/auth/forgot-password",
  RESETPASSWORD: "/auth/reset-password",
  RESETEMAIL:"/auth/reset-email",
  USEREMAILVERIFICATION: "/auth/email-verification",
  NOTIFICATION: "/notification",
  COMMISION: "/commision",
  USER: "/user",
  ADMIN_LOGIN: "/admin/login",
  ADMIN_EVENTS: "/admin/events",
  ADMIN_PROFILE: "/admin/profile",
  ADMIN_DASHBOARD: "/admin",

  //**** Admin Contact US ******************/
  ADMIN_INQUIRY: "/admin/contactus",
  ADD_INQUIRY: "/add-contactus",

  ADMIN_EVENT_CATEGORY: "/admin/event-categories",
  ADMIN_DOCUMENT_TYPE: "/admin/document-type",
  ADMIN_SUBSCRIPTION: "/admin/subscription",
  ADMIN_SUB_ENQ: "/admin/manage-subscription-enquiry",
  ADMIN_GLOBALSETTINGS: "/admin/global-settings",

  MANAGE_PAYMENT_TERMS: "/user/paymentTerms",

  ADMIN_INVOICE: "/admin/invoice",
  ADMIN_TICKET_TRANSACTION_REPORT: "/admin/ticket-sales",
  ADMIN_PITCH_TRANSACTION_REPORT: "/admin/pitch-sales",

  ADMIN_TRADER_SHOP_FRONT: "/admin/shop-front/:unitId",

  //****** ManageContract ********
  ADMIN_CONTRACT: "/admin/contract",

  //*******MANAGE STATIC PAGE CONTENT **********
  ADMIN_STATICPAGE: "/admin/staticPage",

  //********************
  EVENT_FAQ: "/FAQ",
  //**********FAQ ****************
  ADMIN_FAQ_LIST: "/admin/faq",
  ADMIN_FAQ_ADD: "/admin/Faq-add",
  ADMIN_FAQ_EDIT: "/admin/Faq-edit",

  //****** NOTIFICATION  ********
  PROJECT_NOTIFICATION: "/notification",

  //******SHOP FRONT  *****************/
  EVENT_SHOPFRONT_LIST: "/shopfront",
  CREATE_ADD_SHOPFRONT: "/create-shopfront",
  CREATE_EDIT_SHOPFRONT: "/edit-shopfront/:id",

  //****** Manage Event Contract ********
  Event_CONTRACT: "/event/contract/:eventId",
  Event_EDIT_CONTRACT: "/event/edit-contract/:eventId",
  Event_EDIT1_CONTRACT: "/event/create-contract/:eventId",

  //********Event Document **********
  EVENT_DOCUMENT: "/event/document/:eventId",
  EVENT_CREATE_DOCUMENT: "/event/edit-document/:eventId",
  EVENT_CREATE1_DOCUMENT: "/event/create-document/:eventId",

  // ***** Audience *********
  ENENT_AUDENCE: "/event/audience/:eventId",
  EVENT_POST_DATA: "/event/postSales/:eventId",

  //******* Event Map *****************
  EVENT_MAP: "/event/map/:eventId",

  //********* Reports ***********
  EVENT_REPORT_DASHBOARD: "/user",
  EVENT_FEEDBACK_REPORTS: "/user/feedbackReports",
  EVENT_TRADER_REPORTS: "/user/traderReports",
  EVENT_TRANSACTION_REPORTS: "/user/transactionReports",
  EVENT_TICKET_TRANSACTION_REPORTS: "/user/ticketTransactionReports",
  EVENT_PITCH_SALE_REPORTS: "/user/pitchSalesReports",

  //********** GLOBAL SETTINGS ****************
  EVENT_GLOBAL_SETTINGS_LIST: "/event/globalSettings/:eventId",

  PROPERTY: "/property",
  ADD_PROPERTIES: "/add-property",

  ACCOUNT_DASHBOARD: "/users/account-settings",
  ACCOUNT_PROFILEINFO: "/users/user-profile",
  ACCOUNT_PERSONALINFO: "/users/personal-info",
  ACCOUNT_BUSINESSINFO: "/users/business-info",
  ACCOUNT_SUBSCRIPTIONPLANS: "/users/subscription-plans",
  ACCOUNT_CREATE_EVENT: "/users/create-event",
  ACCOUNT_EDIT_EVENT: "/users/edit-event/:eventId",
  ACCOUNT_ACTIVESUBSCRIPTIONP: "/users/active-subscription",
  ACCOUNT_EVENTS: "/users/event-list",
  ACCOUNT_APPLICATIONS: "/users/application-list",
  EVENT_PAGE: "/events",
  ACCOUNT_CREATE_PITCH: "/event/create-pitch/:eventId",
  EVENT_CREATE_APPLICATION: "/event/create-eventapplication/:eventId/:param",
  ACCOUNT_EDIT_PITCH: "/event/edit-pitch/:eventId/:pitchId",
  ACCOUNT_PITCHES: "/event/pitch-list/:eventId",
  CATERS_ACCOUNT_PITCHES: "/event/unit-list/:eventId",
  CATERS_ACCOUNT_CREATE_PITCH: "/event/create-unit/:eventId",
  CATERS_ACCOUNT_EDIT_PITCH: "/event/edit-unit/:eventId/:unitId",
  EVENT_APPLICATION_LANDING: "/users/event-application-landing/:type/:eventId",
  RETAIL_APPLICATION_FORM: "/users/retail-application-form/:eventId/:pitchId",
  CATER_APPLICATION_FORM: "/users/cater-application-form/:eventId/:unitId",
  GLOBAL_EVENTS: "/:type/events",
  SUBMISSION_CATERER: "/events/caterer-submission/:eventId",
  SUBMISSION_RETAILER: "/events/reatailer-submission/:eventId",
  SUBMISSION_CATERER_DETAILS:
    "/events/caterer-submission-details/:eventId/:appId",
  SUBMISSION_RETAILER_DETAILS:
    "/events/reatailer-submission-details/:eventId/:appId",

  SUBMISSION_CATERER_DETAILS_TRADER:
    "/traders/caterer-submission-details/:eventId/:appId",
  SUBMISSION_RETAILER_DETAILS_TRADER:
    "/traders/reatailer-submission-details/:eventId/:appId",
  EVENT_TICKETS: "/event/tickets/:eventId",
  EVENT_CREATE_TICKET: "/event/tickets/create/:eventId",

  TRADER_PROFILE: "/events/shops/:id/:appId",

  ACCOUNT_MANAGE_PAYMENT: "/users/manage-payment",

  // SYNCDB:"/syncdb",
  ERROR: "/*",
  //users/account-settings/
  //admin routes
  ADMIN_EVENT_MANAGE: "/admin/manage-events",
  ADMIN_EVENT_ORGANIZER_LIST: "/admin/organizers",
  ADMIN_EDIT_EVENT_ORGANIZER_PROFILE: "/admin/organizers/edit",
  ADMIN_TRADERS_LIST: "/admin/traders",
  ADMIN_EDIT_TRADER: "/admin/traders/edit",
  ADMIN_TRANSACTIONS_LIST: "/admin/transactions",
  ADMIN_FEEDBACKS_LIST: "/admin/feedbacks",
  ADMIN_MANAGE_EVENTS: "/admin/event-list",
  ADMIN_MANAGE_USERS: "/admin/users",

  //payment second phase
  TRADERS_PAY: "/users/Pay",
  TRADERS_INITIAL_PAY: "/users/initial/Pay",

  TERMS_CONDITION: "/terms-condition",
  PRIVACY_POLICY: "/privacy-policy",
  PRICING: "/pricing",
  EVENT_DETAILS: "/event-details/:eventId",
  ABOUT_US: "/about-us",
  DEFAULT_IMAGE: "/assets/images/watermark.jpg",
  DEFAULT_USER_IMAGE: "/assets/images/users/user-dummy-img.jpg",
  DEFAULT_USER_IMAGE2: "/assets/images/user-test.png",
  NOTIFICATION_LIST: "/notification",
  ADMIN_NOTIFICATION: "/admin/notification",

  //messages
  MESSAGE_INBOX: "/users/messages",
  MESSAGE_LIST: "/users/messages/:id",
  GROUP_MESSAGE_LIST: "/users/messages/group/:id",

  //******Traders Units  *****************/
  TRADER_UNIT_LIST: "/trader/units",
  CREATE_TRADER_UNIT: "/trader/create-unit",
  EDIT_TRADER_UNIT: "/trader/edit-unit/:unitId",
  TRADER_UNIT_SHOPFRONT: "/trader-unit/shopfront/:unitId",
  TRADER_UNIT_DOCUMENT: "/trader-unit/documents/:unitId",
  TRADER_UNIT_CREATE_DOCUMENT:
    "/trader-unit/create-document/:unitId/:documentId",

  REDEEM_USER_TICKET: "/users/redeem-event-ticket",

  TEST_PDF: "/testpdf",
  ERROR_PAGE: "/error-page",
};
